module.exports = __webpack_public_path__ + "img/banner_vertical.d9becf6b.png";